import { floor } from 'lodash-es';

declare global {
  interface Number {
    /**
     * 가격으로 고려하여, ',' 처리, 원 suffix 추가를 합니다.
     *
     * 1,234,567.89원
     */
    withWon: string;
    aimsPriceWon: string;

    /**
     * 가격으로 고려하여, 1원 단위 절삭, ',' 처리, 원 suffix 추가를 합니다.
     *
     * 1,234,567원
     */
    with1Won: string;
    aimsPrice1Won: string;

    /**
     * 가격으로 고려하여, 10원 단위 절삭, ',' 처리, 원 suffix 추가를 합니다.
     *
     * 1,234,560원
     */
    with10Won: string;
    aimsPrice10Won: string;
  }
}

/**
 * Number 타입 플러그인.
 */
export const enableNumberPlugin = () => {
  Object.defineProperties(Number.prototype, {
    withWon: {
      get() {
        return `${this.toLocaleString('ko-KR')}원`;
      },
      configurable: process.env.NODE_ENV === 'development',
    },
    aimsPriceWon: {
      get() {
        return this.withWon;
      },
      configurable: process.env.NODE_ENV === 'development',
    },

    with1Won: {
      get() {
        return floor(this, 0).withWon;
      },
      configurable: process.env.NODE_ENV === 'development',
    },
    aimsPrice1Won: {
      get() {
        return this.with1Won;
      },
      configurable: process.env.NODE_ENV === 'development',
    },

    with10Won: {
      get() {
        return floor(this, -1).withWon;
      },
      configurable: process.env.NODE_ENV === 'development',
    },
    aimsPrice10Won: {
      get() {
        return this.with10Won;
      },
      configurable: process.env.NODE_ENV === 'development',
    },
  });
};
